import { differenceInDays, parseISO } from "date-fns";

export const transformCustomerPaymentSchedule = (payments: any[]) => {
  if (!payments || payments.length === 0) return [];

  return payments
    .sort((a, b) => a.scheduleStep - b.scheduleStep)
    .map((step, idx) => {
      const bookingStart = parseISO(step.booking.bookingDateFrom);
      const dueDate = parseISO(step.dueDate);

      let days: number | undefined = undefined;
      const type: "before booking date" = "before booking date";

      days = differenceInDays(bookingStart, dueDate);

      return {
        stepId: step.id,
        amount: parseFloat(step.amount),
        days,
        dueDate: step.dueDate,
        type,
        idx: idx,
      };
    });
};
